<template>
  <div class="home">
    <Menu v-show="isLoggedIn"></Menu>
    <HelloWorld/>
    <div>
      <v-card max-width="800px" v-show="haveEvents" style="margin-left: auto; margin-right: auto">
        <v-card-title>Upcoming events:</v-card-title>
    <v-simple-table class="text-left">
      <template v-slot:default>
        <thead>
        <tr>
          <th>
            Type
          </th>
          <th>
            Host
          </th>
          <th>
            Location
          </th>
          <th>
            Date
          </th>
        </tr>
        </thead>
        <tbody>
        <tr
            v-for="item in comingUp"
            :key="item.id"
        >
          <td>{{ item.type }}</td>
          <td>{{ item.host.clubName }}</td>
          <td>{{ item.city }}, {{ item.state }}</td>
          <td>{{ $iso2AU(item.startDate) }}</td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
      </v-card>
    </div>
    <LogIn v-show="!isLoggedIn"/>
  </div>
</template>

<script>
// @ is an alias to /src
import Menu from '@/components/Menu.vue'
import HelloWorld from '@/components/HelloWorld.vue'
import LogIn from '@/components/LogIn.vue'
import router from "@/router";
import jwt from "jsonwebtoken";

export default {
  name: 'Home',
  data: () => ({
    comingUp: []
  }),
  components: {
    HelloWorld,
    Menu,
    LogIn
  },
  computed: {
    haveEvents () {
      return this.comingUp.length>0
    },
    isLoggedIn () {
      const token = localStorage.getItem('token')
      if(!token) return false
      const decoded = jwt.decode(token, {complete: true})
      if (decoded == null) return false
      if (decoded.payload.exp < Math.ceil(new Date().getTime()/1000)) {
        localStorage.clear()
        console.log('Cleared expired token')
        return false
      }
      this.$initFromToken(token)
      if (this.$usrStore.token) {
        if(this.$hasRole(['adm','sys'])){
          router.push('members')
        } else {
          router.push('member')
        }
        return true
      } else {
        return false
      }
    }
  },
  mounted: async function () {
    this.$http.post(this.$remote + '/api.trial/nexttrials')
        .then(response => {
          this.comingUp =  response.data.trials
        }).catch(reason => {
          console.log(reason)
    })
  }
}
</script>
